var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.334 8.667.522 1.046c.177.354.266.53.384.684a2 2 0 0 0 .363.363c.154.118.33.207.685.384l1.045.523-1.045.523c-.354.177-.531.265-.685.383a2 2 0 0 0-.363.363c-.118.154-.207.33-.384.685l-.522 1.046-.523-1.046c-.177-.354-.266-.531-.384-.685a2 2 0 0 0-.363-.363c-.154-.118-.33-.206-.685-.383l-1.045-.523 1.045-.523c.354-.177.531-.266.685-.384a2 2 0 0 0 .363-.363c.118-.153.207-.33.384-.684zM10 1.333l.786 2.043c.188.49.282.733.428.94q.197.273.471.47c.206.146.45.24.939.428L14.667 6l-2.043.786c-.489.188-.733.282-.939.428q-.275.197-.47.47c-.147.206-.241.45-.43.94L10 10.667l-.786-2.043c-.188-.49-.282-.734-.428-.94a2 2 0 0 0-.47-.47c-.206-.146-.45-.24-.94-.428L5.333 6l2.043-.786c.49-.188.734-.282.94-.428a2 2 0 0 0 .47-.47c.146-.207.24-.45.428-.94z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgStars;